import React, { useEffect, useRef } from "react";
import * as cornerstone from "cornerstone-core";
import * as cornerstoneWADOImageLoader from "cornerstone-wado-image-loader";
import * as dicomParser from "dicom-parser";
import "./dcm.css";

// Configure the WADO Image Loader
cornerstoneWADOImageLoader.external.cornerstone = cornerstone;
cornerstoneWADOImageLoader.external.dicomParser = dicomParser;

// Register the WADO Image Loader with Cornerstone
cornerstone.registerImageLoader(
  "wadouri",
  cornerstoneWADOImageLoader.wadouri.loadImage
);
cornerstone.registerImageLoader(
  "dicomweb",
  cornerstoneWADOImageLoader.wadouri.loadImage
);

export const DcmViewer = ({ url }) => {
  const canvas = useRef(null);

  useEffect(() => {
    if (!url) {
      console.log("Url not found");
      return;
    }
    displayDicomImage(url);
  }, [url]);

  const displayDicomImage = (url) => {
    if (!canvas.current) {
      console.log("Canvas not found");
      return;
    }
    try {
      cornerstone.enable(canvas.current);
      cornerstone
        .loadImage(`wadouri:${url}`)
        .then((image) => {
          cornerstone.displayImage(canvas.current, image);
        })
        .catch((err) => {
          // This will catch errors from loadImage
          console.error("Error loading DICOM image: ", err);
          if (canvas.current)
            canvas.current.innerHTML =
              "We could not load the preview of this DICOM file.";
        });
    } catch (error) {
      // This will catch synchronous errors, e.g., if cornerstone.enable fails
      console.error("Error displaying DICOM image: ", error);
      if (canvas.current)
        canvas.current.innerHTML =
          "An error occurred while preparing the DICOM preview.";
    }
  };

  return (
    <div
      ref={canvas}
      style={{
        height: "100%",
        transition: "all .5s",
        flex: "1",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    ></div>
  );
};
